import ApiService from '@services/api.service';
import { Notify } from 'quasar';

export const etudiantScoring = {
  state: {
    grille: null,

    sections: [],
    section: null,

    questions: [],
    question: null,

    reponses: [],
    reponse: null,

    session: null,
  },
  mutations: {
    setGrille(state, grille){
      state.grille = grille;
    },
    setSections(state, sections){
      state.sections = sections;
    },
    setSection(state, section){
      state.section = section;
    },
    setQuestions(state, questions){
      state.questions = questions;
    },
    setQuestion(state, question){
      state.question = question;
    },
    setReponses(state, reponses){
      state.reponses = reponses;
    },
    setReponse(state, reponse){
      state.reponse = reponse;
    },
    setSession(state, session){
      state.session = session;
    }
  },
  actions:{
            // GRILLE //
    //Récupération de la grille du cfa de l'utilisateur connecter
    async fetchGrilleByCfa(context, cfa){
      try{
        const response = await ApiService.getRequest('/scoring_grilles', {cfa: cfa});
        context.commit('setGrille', response.data["hydra:member"]);
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite - aucune grille trouvée",
          color: 'red'
        });
      }
    },
    //Récupère la grille
    async fetchGrille(context, uri){
      try{
        const response = await ApiService.getRequest(uri);
        context.commit('setGrille', response.data);
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    },
    //Ajoute une grille à un cfa
    async addGrille(context, data){
      try{
        const response = await ApiService.postRequest('/scoring_grilles', data);
        context.commit('setGrille', response.data);
        if(response.status === 201){
          Notify.create({
            message: "La grille a été enregistrée avec succès",
            color:"green"
          });
        }
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    },
    // Modifie une grille
    async updateGrille(context, data){
      try{
        const response = await ApiService.patchRequest(
          data.url,
          data.datas,
          { 'Content-Type': 'application/merge-patch+json' }
        );
        context.commit('setGrille', response.data);

        if(response.status === 200){
          Notify.create({
            message: "La grille a été modifiée avec succès",
            color:"green"
          });
        }

      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    },
    //Desactive la grille
    async desactiveGrille(context, grille){
      try{
        const response = await ApiService.patchRequest(
          grille,
          { active: false },
          { 'Content-Type': 'application/merge-patch+json' }
        );
        context.commit('setGrille', response.data);
      }catch (e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
      }
    },

    //   SECTIONS  //
    //Ajout de la section
    async addSection(context, data){
      try{
        const response = await ApiService.postRequest('/scoring_sections', data);
        context.commit('setSection', response.data);
        if(response.status === 201){
          Notify.create({
            message: "La section a été enregistrée avec succès",
            color:"green"
          });
        }
        return response.data;
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur est survenue",
          color: 'red'
        })
        throw e;
      }
    },

    //Modifie la section
    async updateSection(context, data){
      try{
        const payload = data.formData instanceof FormData
          ? Object.fromEntries(data.formData)
          : data.formData;
        // Normalise les types (FormData ne produit que des strings)
        if (payload.active !== undefined) {
          payload.active = payload.active === true || payload.active === 'true' || payload.active === 1 || payload.active === '1';
        }
        if (payload.ordre !== undefined) {
          payload.ordre = Number(payload.ordre);
        }
        const response = await ApiService.patchRequest(
          data.url,
          payload,
          { 'Content-Type': 'application/merge-patch+json' }
        );
        context.commit('setSection', response.data);
        if(response.status === 200){
          Notify.create({
            message: "La section a été modifié avec succès",
            color:"green"
          });
        }
        return response.data;
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        throw e;
      }
    },


    //  QUESTIONS //
    //Ajoute la question
    async addQuestion(context, data ){
      try{
        const response = await ApiService.postRequest('/scoring_questions', data);
        context.commit('setQuestion', response.data);
        if(response.status === 201){
          Notify.create({
            message: "Question enregistrer avec succès",
            color: "green"
          })
        }
        return response.data;
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
        throw e;
      }
    },
    //Modifie les questions
    async updateQuestion(context, question){
      try{
        const payload = question.formData instanceof FormData
          ? Object.fromEntries(question.formData)
          : question.formData;
        if (payload.active !== undefined) {
          payload.active = payload.active === true || payload.active === 'true' || payload.active === 1 || payload.active === '1';
        }
        if (payload.is_bloquant !== undefined) {
          payload.is_bloquant = payload.is_bloquant === true || payload.is_bloquant === 'true' || payload.is_bloquant === 1 || payload.is_bloquant === '1';
        }
        if (payload.ordre !== undefined) payload.ordre = Number(payload.ordre);
        if (payload.note_min !== undefined && payload.note_min !== null && payload.note_min !== '') {
          payload.note_min = Number(payload.note_min);
        }
        if (payload.note_max !== undefined && payload.note_max !== null && payload.note_max !== '') {
          payload.note_max = Number(payload.note_max);
        }
        const response = await ApiService.patchRequest(
          question.url,
          payload,
          { 'Content-Type': 'application/merge-patch+json' }
        );
        context.commit('setQuestion', response.data);
        return response.data;
      }catch (e){
        console.error(e);
        Notify.create({
          message: "Une erreur est survenue",
          color: 'red'
        })
        throw e;
      }
    },

    // Soft Delete question
    async desactiveQuestion(context, data){
      try{
        const response = await ApiService.patchRequest(
          data.question,
          { active: Boolean(data.active) },
          { 'Content-Type': 'application/merge-patch+json' }
        );
        context.commit('setQuestion', response.data);
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
      }
    },

    //Suppression Soft Delete
    async removeQuestion(context, question){
      try{
        const response = await ApiService.patchRequest(
          question,
          { is_deleted: true },
          { 'Content-Type': 'application/merge-patch+json' }
        );
        context.commit('setQuestion', response.data);
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
      }
    },

    //   SESSION D'EVALUATION //
    //Récupère la session par l'admision record
    async fetchSession(context, idAdmissionRecord){
      try{
        const encodedIri = encodeURIComponent(idAdmissionRecord);
        const response = await ApiService.getRequest(`scoring_sessions?admissionRecord=${encodedIri}`);
        context.commit('setSession', response.data['hydra:member']);

      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red',
        })
      }
    },
    async fetchSessionByEtudiant(context, idEtudiant){
      try{
        const encodedIri = encodeURIComponent(idEtudiant);
        const response = await ApiService.getRequest(`scoring_sessions?etudiants=${idEtudiant}`);
        context.commit('setSession', response.data['hydra:member']);
      }catch(error){
        console.error(error);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red',
        })
      }
    },
    //Ajoute la session de l'évaluation
    async addSession(context, data){
      try{
        const response = await ApiService.postRequest('scoring_sessions', data,
        {
          headers: { 'Content-Type': 'application/json' }
        });
        context.commit("setSession", response.data);
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite lors de la sauvegarde",
          color: "red"
        })
      }
    },
    // Modifie la session de l'évaluation
    async editSession(context, data) {
      try {
        const response = await ApiService.patchRequest(
          data.url,
          data.data,
          { 'Content-Type': 'application/merge-patch+json' }
        );
        context.commit("setSession", response.data);
        return response.data;
      } catch (e) {
        console.error(e);
        Notify.create({ message: "Une erreur s'est produite", color: "red" });
        throw e;
      }
    },

    //   REPONSES    //
    //Sauvegarde la réponse à une question définie
    async addReponse(context, data){
      try{
        const response = await ApiService.postRequest("/scoring_reponses", data);
        context.commit('setReponses', response);
        if(response.status === 201){
          Notify.create({
            message: "L'enregistrement des données a été effectué avec succès",
            color: 'green'
          })
        }
        return response.data;
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite lors de l'enregistrement",
          color: 'red'
        })
        throw e;
      }
    },
    //Modifie une reponse
    async editReponse(context, data){
      try{
        const response = await ApiService.patchRequest(
          data.url,
          data.reponse,
          { 'Content-Type': 'application/merge-patch+json' }
        );
        context.commit('setReponse', response.data);
        if(response.status === 200){
          Notify.create({
            message: "L'enregistrement des données a été effectué avec succès",
            color: 'green'
          })
        }
        return response.data;
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite lors de l'enregistrement",
          color: 'red'
        })
        throw e;
      }
    },
  },
  getters : {
    getScoringGrille(state){
      return state.grille;
    },
    getReponses(state){
      return state.reponses;
    },
    getReponse(state){
      return state.reponse;
    },
    getScoringSession(state){
      return state.session;
    },
    getSection(state){
      return state.section;
    },
    getQuestion(state) {
      return state.question;
    }
  }
}
